import { MODULE_NAME } from '../constants';
export const selectExtensionsList = (state) => state[MODULE_NAME].list;
export const selectExtension = (state) => state[MODULE_NAME].extension;
